export default __webpack_public_path__ + "static/media/ojos-normal-verde.805ca020.png";